/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![GroupPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABmklEQVR4nOWUy0rDUBCGA+oDeEEQwZXowrWXXR8gOTMT8HSmtV0acSP0Idy59VVcuBKr4s4ncKvUS4t4Q0EjJ016iW3T1nTlQDicw5n/n/nmEMv6d6Hc7IYivgSSV0C+MPvUxF13a04R14DEb378ZM5TMwCU23YD8RXxrpVWOI5eAOTrVAyIcmuK5ByIX8xq9oGJm10Fku9QvDYUogAHcTXGuxqJAfJxYA6yPlT1iLmdOOuwYs9KI4xQJwMg2Q46AAGFfAMoR4qkoLUeSxvRSayzK6X04kAmZqiAcqZQns1qhtvoELnyuzs+sNIKB7kIyO8K5QNc2bPt/GTfyZ7nTSBy3vAFlLsAAcpjnLdSsjLwrwJALxueXQbsR7yJeKk1L3iyyOWe4iYJiO97iUNkglxx3cJso7DwvKt4JpMZT6oc6sKfAFJynNxMW+dJBoZtP5UDSKkj2iSDYKB9GBAVpxvMk+63ziR6LUB82CtJaz1Vv8/lRJwkp01EKG8K+cu29fxoEJHsR44K+SFhyJsDG/w1Rm+AXG5jHsYPZdCVvJfS1xwAAAAASUVORK5CYII=)
 */
export const GroupPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M14.5 8a3 3 0 1 0-2.7-4.3c-.2.4.06.86.44 1.12a5 5 0 0 1 2.14 3.08c.01.06.06.1.12.1ZM16.62 13.17c-.22.29-.65.37-.92.14-.34-.3-.7-.57-1.09-.82-.52-.33-.7-1.05-.47-1.63.11-.27.2-.57.26-.87.11-.54.55-1 1.1-.92 1.6.2 3.04.92 4.15 1.98.3.27-.25.95-.65.95a3 3 0 0 0-2.38 1.17ZM15.19 15.61c.13.16.02.39-.19.39a3 3 0 0 0-1.52 5.59c.2.12.26.41.02.41h-8a.5.5 0 0 1-.5-.5v-2.1c0-.25-.31-.33-.42-.1-.32.67-.67 1.58-.88 2.54a.2.2 0 0 1-.2.16A1.5 1.5 0 0 1 2 20.5a7.5 7.5 0 0 1 13.19-4.89ZM9.5 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM15.5 22Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
